export const colors = {
  red: 'rgba(239,83,80,0.87)',
  green: '#44D7B5',
  yellow: '#F8941C',
  black: '#424242',
  white: '#ffffff',
  lightDivider: '#E0E0E0',
  darkDivider: '#515151',
  offwhite: '#F6F7F9',
  offblack: '#7b7b7b',
  dark: '#393939',
  offdark: '#1F2427',
  blue: '#1976D2',
  indigo: '#15b4db',
  pink: '#FEAAAA',
  teal: '#1BB8A3',
  pinky: '#ff4081',
  grey: '#797979',
  lightGrey: '#AEAEAE',
  light: '#E7E7E7',
  orange: '#FF7851',
  lightIndigo: '#E8F0FD'
}

const MaterialColors = [
  colors.green,
  colors.orange,
  colors.indigo,
  colors.pinky,
  colors.red,
  colors.teal
]

const generateRandomNumber = (max) => Math.floor(Math.random() * max)
export const getRandomColor = () => MaterialColors[generateRandomNumber(6)]

export const getContrastYIQFromHex = (hexColor) => {
  const r = parseInt(hexColor.substring(1, 3), 16)
  const g = parseInt(hexColor.substring(3, 5), 16)
  const b = parseInt(hexColor.substring(5, 7), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? 'black' : 'white'
}

export const componentToHex = (c) => {
  const hex = c.toString(16)
  return hex.length === 1 ? '0' + hex : hex
}

export const getContrastColor = (color) => {
  if (color.startsWith('rgba')) {
    const components = color.match(/[\d.]+/g)
    let r = Math.round(parseFloat(components[0]))
    let g = Math.round(parseFloat(components[1]))
    let b = Math.round(parseFloat(components[2]))
    const a = parseFloat(components[3])
    if (a < 1) {
      r = Math.round((1 - a) * 255 + a * r)
      g = Math.round((1 - a) * 255 + a * g)
      b = Math.round((1 - a) * 255 + a * b)
    }
    const hexColor = '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
    return getContrastYIQFromHex(hexColor)
  } else return getContrastYIQFromHex(color)
}
